/**
 * This component is the loader without the shadow screen
 */
const Loader = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-solid border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  )
}

export default Loader